// C:\Projects\texe-web\src\services\batch.ts
import { apiPost, getToken } from "../lib/api";

export type LikeState = { id: string; count: number; liked: boolean };
export type FollowStatus = { id: string; following: boolean; followsMe: boolean };
export type BlockRelation = "none" | "i_blocked" | "blocked_me" | "both";
export type BlockStatus = { id: string; relation: BlockRelation };

export async function fetchBatchLikeState(opts: {
  postIds?: string[];
  commentIds?: string[];
}): Promise<{ posts: LikeState[]; comments: LikeState[] }> {
  // Giriş yapmamışsa boş döndür
  if (!getToken()) {
    return { posts: [], comments: [] };
  }
  
  const body: any = {};
  if (opts.postIds?.length) body.postIds = [...new Set(opts.postIds)];
  if (opts.commentIds?.length) body.commentIds = [...new Set(opts.commentIds)];
  if (!body.postIds && !body.commentIds) return { posts: [], comments: [] };

  try {
    const data = await apiPost<{ ok: true; posts: LikeState[]; comments: LikeState[] }>(
      `/api/likes/state/batch`,
      body
    );
    return { posts: data.posts ?? [], comments: data.comments ?? [] };
  } catch {
    return { posts: [], comments: [] };
  }
}

export async function fetchBatchFollowStatus(userIds: string[]): Promise<FollowStatus[]> {
  // Giriş yapmamışsa boş döndür
  if (!getToken()) {
    return [];
  }
  
  const ids = [...new Set(userIds)].filter(Boolean);
  if (!ids.length) return [];
  
  try {
    const data = await apiPost<{ ok: true; items: FollowStatus[] }>(`/api/follow/status/batch`, {
      userIds: ids,
    });
    return data.items ?? [];
  } catch {
    return [];
  }
}

export async function fetchBatchBlockStatus(userIds: string[]): Promise<BlockStatus[]> {
  // Giriş yapmamışsa boş döndür
  if (!getToken()) {
    return [];
  }
  
  const ids = [...new Set(userIds)].filter(Boolean);
  if (!ids.length) return [];
  
  try {
    const data = await apiPost<{ ok: true; items: BlockStatus[] }>(`/api/blocks/status/batch`, {
      userIds: ids,
    });
    return data.items ?? [];
  } catch {
    return [];
  }
}
